import { Link } from "react-router-dom";
import { Article } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function ArticleCard({ article }: { article: Article }) {
  const cat = categories.find((c) => c.slug === article.category);
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-100">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 抖漫速看精选`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 rounded-full bg-background-950/70 px-3 py-1 text-xs text-background-50 backdrop-blur">
          {cat?.name ?? "抖漫"}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2">{article.excerpt}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-time-line"></i> {article.readTime}
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-eye-line"></i> {article.views}
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">{article.date}</span>
        </div>
      </div>
    </Link>
  );
}